export const getCityFromAddress = (address = "") => {
  const parts = address.split(",").map((part) => part.trim()).filter(Boolean);
  return parts.length >= 3 ? parts[parts.length - 2] : "";
};

export const getListingDisplayTitle = ({ title, address, bedrooms, city }) => {
  const customTitle = (title || "").trim();
  if (customTitle && customTitle !== (address || "").trim()) return customTitle;

  const location = (city || getCityFromAddress(address)).trim();
  const bedroomCount = String(bedrooms ?? "").trim();
  const homeType = bedroomCount === "0"
    ? "Studio"
    : bedroomCount
      ? `${bedroomCount}-Bedroom Home`
      : "Home";

  return `${homeType} for Rent${location ? ` in ${location}` : ""}`;
};